import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Angiv notifikationens titel',
    },
    body: {
      label: 'Beskedtekst',
      placeholder: 'Skriv din besked',
    },
    promo_code: {
      label: 'Rabatkode',
      placeholder: 'Vælg rabatkode',
    },
    offers: {
      label: 'Tilbud',
      placeholder: 'Vælg tilbud',
    },
    campaign_type: {
      label: 'Kampagnetype',
      placeholder: 'Vælg kampagnetype',
    },
    tone: {
      label: 'Tonefald',
      placeholder: 'Vælg et tonefald',
    },
  },
  attachment: {
    heading: 'Hvad skal kampagnen promovere?',
    offer: {
      title: 'Tilbud',
      description: 'Vælg blandt dine aktive tilbud.',
    },
    promo_code: {
      title: 'Rabatkode',
      description: 'Vælg blandt dine aktive rabatkoder.',
    },
  },
  buttons: {
    generate: 'Generér',
    improve: 'Forbedr med AI',
    undo: 'Fortryd ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Venlig 🙂',
    [ToneTypes.Elegant]: 'Elegant ✨',
    [ToneTypes.Playful]: 'Legende 🎉',
    [ToneTypes.Professional]: 'Professionel 👨‍💼',
    [ToneTypes.Informative]: 'Informativ 📊',
    [ToneTypes.Persuasive]: 'Overbevisende 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Salgsfremmende 🚀',
    [CampaignTypes.Informational]: 'Informerende ℹ️',
  },
  no_promo_codes: {
    title: 'Ingen egnede rabatkoder',
    description: 'Opret en ny rabatkode.',
    create_promo_code: 'Opret rabatkode',
  },
  no_offers: {
    title: 'Ingen aktive tilbud',
    description: 'Opret et nyt tilbud.',
    create_offer: 'Opret tilbud',
  },
  feedback: {
    success: 'Genereret',
    error: 'Generering mislykkedes',
  },
};
